import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { IconComponent} from '@softline/ui-core';
import { PriceCardComponent } from '../price-card/price-card.component';
import { SupplierPromotion } from '../../types/supplier-promotion';
import { PromotionCardComponent } from '../promotion-card/promotion-card.component';

@Component({
    selector: 'soft-supplier-promotion-card',
    imports: [PriceCardComponent, PromotionCardComponent, IconComponent],
    templateUrl: './supplier-promotion-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './supplier-promotion-card.component.css'
})
export class SupplierPromotionCardComponent {
  supplierPromotion = input.required<SupplierPromotion>();
}
